import {showMessage} from 'exsportia-components'
import {call, takeLeading} from 'redux-saga/effects'

import {API} from '../../networking/http'
import {createOpnTokenRequest, createStripeCheckoutRequest} from './actions'
import {requestExternalLink} from './external-link'
import {StripeCheckoutRequestDataType} from './types'

export type StripeCheckoutResType = {
  status: number
  data: string
}

export type OpnCreateTokenResType = {
  status: number
  message: string
  data: {
    authorize_uri: string
  }
}

export function* handleCreateStripeCheckoutRequest(payload: StripeCheckoutRequestDataType) {
  try {
    // yield put(loadingStart());
    // const options = {
    //   data: payload,
    // }
    const endpoint = 'payments/stripe/checkout'
    const res = (yield call<typeof API['post']>(API.post, endpoint, payload)) as StripeCheckoutResType
    if (res.status === 200) {
      // Opened from the customer's click in ExternalLinkGate, not from here (WBA-3926).
      requestExternalLink(res.data)
    }
    // yield put(loadingEnd());
  } catch (error) {
    // yield put(loadingEnd());
    // showMessage(
    //   `Error: ${R.pathOr('Something went wrong', ['response', 'data', 'message'], error)}`,
    //   'error'
    // );
  }
}
export function* handleCreateOpnTokenRequest(payload: StripeCheckoutRequestDataType) {
  try {
    const endpoint = 'payments/opn/token'
    const res = (yield call<typeof API['post']>(API.post, endpoint, payload)) as OpnCreateTokenResType
    if (res.status === 200) {
      const payment = res.data
      if (payment.authorize_uri) {
        requestExternalLink(payment.authorize_uri)
      }
    } else {
      showMessage(`Error: ${res.message}`, 'error')
    }
  } catch (error) {
    // showMessage(error);
  }
}

export function* paymentsWatcherSaga() {
  yield takeLeading(createStripeCheckoutRequest, function* (action) {
    yield handleCreateStripeCheckoutRequest(action.payload)
  })
  yield takeLeading(createOpnTokenRequest, function* (action) {
    yield handleCreateOpnTokenRequest(action.payload)
  })
}
